module.exports = __webpack_public_path__ + "img/2018-01-20.5845dcc9.jpg";